import { SET_ACTIVE_SERVICE } from "../actions/activeService";

const activeServiceIdInitialState = 1;

const activeServiceReducer = (state = activeServiceIdInitialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SERVICE:
      return action.payload;
    default:
      return state;
  }
};

export default activeServiceReducer;
